import React from "react";
import styled, { keyframes } from "styled-components";
import logo1 from "../images/logo.png";
import logo2 from "../images/SNU.png";
import shadowBgImg from "../images/contact-us-shadow-bg.png";
import { InView } from "react-intersection-observer";
import contactUsBg from "../images/contact-us-bg.webp";
import {
  EmailIcon,
  FaceBookIcon,
  InstagramIcon,
  LinkedInIcon,
  LocationIcon,
  PhoneIcon,
  TimeIcon,
} from "./icon";
import { useToast } from "@chakra-ui/react";
import ReactSelect from "react-select";
import { useState } from "react";
import axios from "axios";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(50px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const Loader = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #28a745;
  border-radius: 50%;
  border-top-color: #fff;
  animation: ${rotate} 2s linear infinite;
`;

const AddressContainer = styled.div`
  height: 100%;
  background-image: url(${contactUsBg});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  width: 50%;
  padding: 32px 60px;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 820px) {
    width: 100%;
    padding: 32px 16px;
  }
`;

const SectionContainer = styled.div`
  padding: 80px 0px;
  display: flex;
  width: 100%;

  @media screen and (max-width: 780px) {
    padding: 32px 0px;
    gap: 30px;
  }

  @media screen and (max-width: 820px) {
    padding: 32px 0px;
    flex-direction: column;
    gap: 30px;
  }

`;

const ContactForm = styled.form`
  position: relative;
  background-color: "transparent";
  display: flex;
  flex-direction: column;
  width: 50%;
  border: 5px;

  @media screen and (max-width: 820px) {
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    border-radius: 0 5px 5px 0;
  }
  @media screen and (min-width: 1024px) {
    padding-right: 65px;
  }
`;

const SectionTitle = styled.h5`
  font-size: 64px;
  line-height: 77px;
  font-weight: 500;
  color: ${(props) => (props.color === "yellow" ? "#F7CB57" : "#1F1F1F")};
  margin-bottom: ${(props) => (props.color === "yellow" ? "8px" : "0px")};

  @media screen and (max-width: 780px) {
    font-size: 32px;
    line-height: 40px;
    font-weight: 700;
  }
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 1rem;
  width: 100%;
  position: relative;
`;

const Label = styled.label`
  font-family: "Nunito";
  font-size: 14px;
  font-weight: 500;
  color: #302e2e;
  margin-bottom: 6px;
`;

const Input = styled.input`
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 400;
  color: #514e4e;

  padding: 10px 14px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;

  @media screen and (max-width: 767px) {
    font-size: 1rem;
  }
`;

const TextArea = styled.textarea`
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 400;
  color: #514e4e;

  padding: 10px 14px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  min-height: 150px;

  @media screen and (max-width: 767px) {
    font-size: 1.1rem;
  }
`;

const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "8px",
    borderColor: "#D0D5DD",
    fontSize: "1rem",
    color: "#514E4E",
    padding: "0.2rem",
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "1rem",
  }),
};

const SubmitButton = styled.button`
  margin-top: auto;
  font-family: "Barlow";
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px;
  font-size: 18px;
  background-color: #af3c2c;
  color: #fff;
  cursor: pointer;
  border: none;
  border-radius: 2px;
  transition: 0.3s ease-in-out;
`;

const Tick = styled.span`
  color: #28a745;
  font-size: 20px;
  font-weight: bold;
`;

const ShadowBg = styled.img`
  width: 65px;
  height: 330px;
  object-fit: cover;
  object-position: center top;
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  @media screen and (max-width: 780px) {
    right: -20px;
  }
`;
const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
  font-size: 14px;
  color: #fff;
  animation: ${fadeInUp} 1s ease-in-out forwards;
  margin-top: ${(props) => (props.marginTop === "14" ? "14px" : "0px")};
`;

const CompanyInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Logo = styled.img`
  width: 80px;
  object-fit: contain;
  height: 90px;
  margin-right: 1rem;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 1rem;
  }
`;

const Info = styled.div`
  display: flex;
  gap: 1rem;
`;

const CompanyName = styled.h3`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #fff;
`;

const CompanyAddress = styled.p`
  font-size: 14px;
  margin-bottom: 10px;
  margin-bottom: 0.5rem;

  @media screen and (max-width: 480px) {
    max-width: 85%;
  }
`;

const CompanyEmail = styled.a`
  margin-bottom: 0.5rem;
  display: block;
  text-decoration: underline;
  color: #fff;
`;

const CompanyPhone = styled.a`
  margin-bottom: 0.5rem;
  display: block;
  text-decoration: underline;
  color: #fff;
`;

const LeftSectionTitle = styled.h1`
  margin-bottom: 16px;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
`;

const LeftSectionTxt = styled.p`
  margin-bottom: 2rem;
  font-size: 16px;
  color: #fff;
`;

const OpeningTimes = styled.p`
  margin-bottom: 0.5rem;
`;

const IconsContainer = styled.div`
  margin-top: 34px;
`;

const IconsContainerTitle = styled.h5`
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
`;

const IconsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const SendMsg = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    topic: "",
    place: "",
  });
  const toast = useToast();

  const handleChange = (event) => {
    const { id, value } = event.target;
    setFormState((prevState) => ({ ...prevState, [id]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      await axios.post(
        "https://education-project-deploy-01c3d0549de6.herokuapp.com/send-email",
        formState
      );
      toast({
        title: "Success.",
        description: "Email sent successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      setFormState({
        name: "",
        email: "",
        phone: "",
        message: "",
        topic: "",
        place: "",
      });
      setIsSent(true);
      setTimeout(() => {
        setIsSent(false);
        setIsLoading(false);
      }, 5000);
    } catch (error) {
      console.error(error);
      toast({
        title: "An error occurred.",
        description: "Unable to send the email.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SectionContainer>
      <ContactForm onSubmit={handleSubmit}>
        <ShadowBg alt="shadow-bg-img" src={shadowBgImg} />
        <SectionTitle>Send Us a</SectionTitle>
        <SectionTitle color="yellow">Message</SectionTitle>
        <FormField>
          <Label htmlFor="name">Name</Label>
          <Input
            placeholder="e.g., John Doe"
            type="text"
            id="name"
            value={formState.name}
            onChange={handleChange}
            required
          />
        </FormField>
        <FormField>
          <Label htmlFor="email">Email</Label>
          <Input
            placeholder="example@gmail.com"
            type="email"
            id="email"
            value={formState.email}
            onChange={handleChange}
            required
          />
        </FormField>
        <FormField>
          <Label htmlFor="phone">Phone Number</Label>
          <Input
            placeholder="+95-12345678"
            type="tel"
            id="phone"
            value={formState.phone}
            onChange={handleChange}
          />
        </FormField>
        <FormField>
          <Label htmlFor="topic">Your question is regarding?</Label>
          <ReactSelect
            id="topic"
            styles={customSelectStyles}
            placeholder="-Select-"
            value={
              formState.topic
                ? { value: formState.topic, label: formState.topic }
                : null
            }
            onChange={(option) =>
              handleChange({ target: { id: "topic", value: option.value } })
            }
            options={[
              {
                value: "Universities/Colleges",
                label: "Universities/Colleges",
              },
              { value: "Scholarship", label: "Scholarship" },
              { value: "Visa", label: "Visa" },
              { value: "Course Info", label: "Courses" },
              { value: "Payment", label: "Payment" },
            ]}
          />
        </FormField>
        <FormField>
          <Label htmlFor="place">Preferred study destination</Label>
          <ReactSelect
            id="place"
            styles={customSelectStyles}
            placeholder="-Select-"
            value={
              formState.place
                ? { value: formState.place, label: formState.place }
                : null
            }
            onChange={(option) =>
              handleChange({ target: { id: "place", value: option.value } })
            }
            options={[
              { value: "United Kingdom", label: "United Kingdom" },
              { value: "Australia", label: "Australia" },
              {
                value: "United States Of America",
                label: "United States Of America",
              },
              { value: "Canada", label: "Canada" },
              { value: "Singapore", label: "Singapore" },
              { value: "Thailand", label: "Thailand" },
            ]}
          />
        </FormField>
        <FormField>
          <Label htmlFor="message">Message</Label>
          <TextArea
            id="message"
            value={formState.message}
            onChange={handleChange}
            required
          />
        </FormField>
        <SubmitButton type="submit">
          {isLoading ? <Loader /> : isSent ? <Tick>&#10003;</Tick> : "Submit"}
        </SubmitButton>
      </ContactForm>
      <AddressContainer>
        <LeftSectionTitle>Talk with our expects</LeftSectionTitle>
        <LeftSectionTxt>
          Please fill out the form and one of our experts will get in touch with
          you shortly.
        </LeftSectionTxt>
        <InView triggerOnce threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              style={{ animationPlayState: inView ? "running" : "paused" }}
            >
              <CompanyInfo>
                <Logo src={logo1} alt="SafeNet Education" />
                <Info>
                  <CompanyName>SafeNet Education </CompanyName>
                </Info>
                <Info>
                  <LocationIcon w={16} h={18} />
                  <CompanyAddress>
                    No.1106, 11th Floor, Pearl Condo, Block C, Bahan Township,
                    Yangon
                  </CompanyAddress>
                </Info>
                <Info>
                  <EmailIcon w={16} h={18} />
                  <CompanyEmail href="mailto:safeneteducation@gmail.com">
                    safeneteducation@gmail.com
                  </CompanyEmail>
                </Info>
                <Info>
                  <PhoneIcon w={16} h={16} />
                  <CompanyPhone href="tel:+959967561128">
                    +95 (9) 967561128
                  </CompanyPhone>
                </Info>
                <Info>
                  <TimeIcon w={16} h={16} />
                  <OpeningTimes>Mon - Fri: 9am - 5pm</OpeningTimes>
                </Info>
              </CompanyInfo>
              <CompanyInfo marginTop="14">
                <Logo src={logo2} alt="SafeNet Group" />
                <Info>
                  <CompanyName>SafeNet Group</CompanyName>
                </Info>
                <CompanyInfoWrapper>
                  <Info>
                    <LocationIcon w={14} h={18} />
                    <CompanyAddress>
                      Ground Floor, Pearl Condo, Block C, Bahan Township, Yangon
                    </CompanyAddress>
                  </Info>
                  <Info>
                    <EmailIcon w={16} h={18} />
                    <CompanyEmail href="mailto:sales@safenetgroups.com">
                      sales@safenetgroups.com
                    </CompanyEmail>
                  </Info>
                  <Info>
                    <PhoneIcon w={16} h={16} />
                    <CompanyPhone href="tel:+9595136885">
                      +95 (9) 5136885
                    </CompanyPhone>
                  </Info>
                  <Info>
                    <TimeIcon w={16} h={16} />
                    <OpeningTimes>Mon - Fri: 9am - 5pm</OpeningTimes>
                  </Info>
                </CompanyInfoWrapper>
              </CompanyInfo>
              <IconsContainer>
                <IconsContainerTitle>Follow us</IconsContainerTitle>
                <IconsWrapper>
                  <FaceBookIcon fill={"#F1F1F1"} bg={"#AF3C2C"} />
                  <InstagramIcon fill={"#F1F1F1"} bg={"#AF3C2C"} />
                  <LinkedInIcon fill={"#F1F1F1"} bg={"#AF3C2C"} />
                </IconsWrapper>
              </IconsContainer>
            </div>
          )}
        </InView>
      </AddressContainer>
    </SectionContainer>
  );
};

export default SendMsg;
